import SingleWirePage from "components/pages/SingleWirePage";
import React from "react";

export default function CaptureSingleWire(props) {
  return (
    <SingleWirePage />
  )
}
